import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { OptionCard } from 'components/OptionCard'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import { CustomPageId } from 'page-constants'
import { Color, Language, OptionType } from 'root-constants'

import { StyledSelectGenderArchetype as S } from './SelectGenderArchetype.styles'
import { ARCHETYPE_GENDER_OPTIONS } from './constants'

export const SelectGenderArchetype: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const [answer, setAnswer] = useState<string>('')

  const handleContinue = useNextStep({
    pageId: CustomPageId.GENDER,
    question: t('onboarding.selectGenderArchetype.title', {
      lng: Language.EN,
    }),
    nextPagePath,
    isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Container>
      <S.Title>{t('onboarding.selectGenderArchetype.title')}</S.Title>
      <S.Subtitle>
        <Trans i18nKey="onboarding.selectGenderArchetype.subtitle" />
      </S.Subtitle>

      <S.CardsContainer>
        {ARCHETYPE_GENDER_OPTIONS.map(({ value, text, imageUrl }) => (
          <OptionCard
            key={value}
            imageUrl={imageUrl}
            value={value}
            label={t(text)}
            checked={answer === value}
            disabled={isAnswersDisabled}
            $backgroundColor={Color.SKY_DARK}
            $renderImageAsImg
            name={pageId}
            type={OptionType.RADIO}
            onChange={handleAnswerChange}
          />
        ))}
      </S.CardsContainer>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsGenderTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Container>
  )
}
